import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcTelemetryHandler } from './rpc-telemetry-handler';
import { RpcTelemetryKey, RpcTelemetryRecord } from './rpc-telemetry-model';

/**
 * Rpc telemetry subject interface.
 */
export interface RpcTelemetrySubject extends Subject<DeferredData<RpcTelemetryRecord, void>> {}

/**
 * The class to implement Rpc telemetry with Subject server.
 */
export class RpcTelemetrySubjectServer extends RpcSubjectServer<RpcTelemetryRecord, void> implements RpcTelemetryHandler {
    /**
     * Initializes a new instance of the RpcTelemetrySubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcTelemetryKey.command);
    }

    /**
     * The handler to respond a request for RpcTelemetry call.
     *
     * @param data The RPC telemetry record object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcTelemetryRecord): Promise<void> {
        return this.processNextForSubject(RpcTelemetryKey.command, data);
    }
}
